import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-code-verifier',
  templateUrl: './code-verifier.component.html',
  styleUrls: ['./code-verifier.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CodeVerifierComponent {
  public codeLength = 6;
  private _form: FormGroup;

  public get form(): FormGroup {
    return this._form;
  }
  @Input() public set form(value: FormGroup) {
    for (let i = 0; i < this.codeLength; i++) {
      value.addControl(`num${i}`, new FormControl(``, [Validators.required]));
    }
    this._form = value;
  }

  public get width(): number {
    return 100 / this.codeLength;
  }

  public placeholder(i: number): number {
    return ++i;
  }
  public control(key): FormControl {
    return this.form?.get(key) as FormControl;
  }

  public get keys(): string[] {
    return Object.keys(this.form?.controls || {});
  }

  public onInput(event): void {
    const el = event.code === 'Backspace'
      ? event.srcElement.previousElementSibling
      : event.srcElement.nextElementSibling;

    if (el !== null) {
      el.focus();
    }
  }

  public onPaste(event, i: number): void {
    if (i === 0) {
      const pastedText = event.clipboardData.getData('text');

      for (const [index, key] of this.keys.entries()) {
        this.form.get(key).setValue(pastedText.charAt(index));
      }
    }
  }
}
